export const INFINITY_SYMBOL = 'ထ';
